import { render, staticRenderFns } from "./VisualRankCardView.vue?vue&type=template&id=657de4d8&scoped=true&"
import script from "./VisualRankCardView.vue?vue&type=script&lang=js&"
export * from "./VisualRankCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657de4d8",
  null
  
)

export default component.exports